module.exports = __webpack_public_path__ + "media/application/images/svgs/trash-a0d1a96646b5169ca9a0366785e5d5ae.svg";